import emailMask from 'text-mask-addons/dist/emailMask';
export const EmailMask = emailMask;
